import { Todo } from 'api/clients/TodoClient'

export enum TodosActions {
  UPSERT_TODO = 'UPSERT_TODO',
  UPSERT_TODOS = 'UPSERT_TODOS',
  DELETE_TODO = 'DELETE_TODO',

  SET_ACTIVE_TODO = 'SET_ACTIVE_TODO',
  SET_HIGHLIGHTED_TODO = 'SET_HIGHLIGHTED_TODO',
}

export function upsertTodo(todo: Todo) {
  return {
    type: TodosActions.UPSERT_TODO,
    payload: { todo },
  }
}

export function upsertTodos(todos: Todo[]) {
  return {
    type: TodosActions.UPSERT_TODOS,
    payload: { todos },
  }
}

export function deleteTodo(id: number) {
  return {
    type: TodosActions.DELETE_TODO,
    payload: { id },
  }
}

export function setActiveTodo(id?: number) {
  return {
    type: TodosActions.SET_ACTIVE_TODO,
    payload: { id },
  }
}

export function setHighlightedTodo(id?: number) {
  return {
    type: TodosActions.SET_HIGHLIGHTED_TODO,
    payload: { id },
  }
}
